import catalog from './catalog.json';
import uk from './i18n/uk.json';
import ro from './i18n/ro.json';
import { normalizeLang } from '../lib/contentLocale';

export const foods = catalog.foods;
export const guides = catalog.guides;
export const mealPlans = catalog.mealPlans;
export const recipes = catalog.recipes;

export function marketForLang(lang) {
  const code = String(lang || 'en')
    .toLowerCase()
    .split('-')[0];
  if (code === 'uk') return 'UA';
  if (code === 'en') return 'UK';
  return 'US';
}

export function recipeInMarket(recipe, lang) {
  const market = marketForLang(lang);
  return Array.isArray(recipe?.markets) && recipe.markets.includes(market);
}

export function recipesForLang(list, lang) {
  return (list || []).filter((recipe) => recipeInMarket(recipe, lang));
}

const overlays = { uk, ro };

function isObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value);
}

function mergeLocalized(base, overlay) {
  if (!overlay) return base;
  const out = { ...base, ...overlay };
  ['canBabiesEat', 'whenToIntroduce', 'reviewedBy'].forEach((key) => {
    if (isObject(base[key]) || isObject(overlay[key])) {
      out[key] = { ...(base[key] || {}), ...(overlay[key] || {}) };
    }
  });
  if (Array.isArray(base.servings) && Array.isArray(overlay.servings)) {
    out.servings = base.servings.map((serving, index) => ({
      ...serving,
      ...(overlay.servings[index] || {}),
    }));
  }
  if (Array.isArray(base.cutExamples) && Array.isArray(overlay.cutExamples)) {
    out.cutExamples = base.cutExamples.map((cut, index) => ({
      ...cut,
      ...(overlay.cutExamples[index] || {}),
    }));
  }
  if (Array.isArray(base.faqs) && Array.isArray(overlay.faqs)) {
    out.faqs = base.faqs.map((faq, index) => ({
      ...faq,
      ...(overlay.faqs[index] || {}),
    }));
  }
  if (Array.isArray(base.sections) && Array.isArray(overlay.sections)) {
    out.sections = base.sections.map((section, index) => {
      const extra = overlay.sections[index] || {};
      const merged = { ...section, ...extra };
      if (Array.isArray(section.meals) && Array.isArray(extra.meals)) {
        merged.meals = section.meals.map((meal, mealIndex) => ({
          ...meal,
          ...(extra.meals[mealIndex] || {}),
        }));
      }
      return merged;
    });
  }
  return out;
}

export function localizeItem(item, lang) {
  const resolved = normalizeLang(lang);
  if (!item || resolved === 'en') return item;
  return mergeLocalized(item, overlays[resolved]?.[item.type]?.[item.slug]);
}

function bySlug(items, slug) {
  return items.find((item) => item.slug === slug) || null;
}

export const getFoodBySlug = (slug) => bySlug(foods, slug);
export const getGuideBySlug = (slug) => bySlug(guides, slug);
export const getMealPlanBySlug = (slug) => bySlug(mealPlans, slug);
export const getRecipeBySlug = (slug) => bySlug(recipes, slug);
